export default {
  'Common.AdAccount': 'AdWords-Konto',
  'Common.Agree': 'Ja, ich stimme zu',
  'Common.Attention': 'ACHTUNG',
  'Common.BackToAllVisits': 'Zurück zu allen Besuchen',
  'Common.BackToDetails': 'ZURÜCK ZU DETAILS',
  'Common.BackToOverview': 'Zurück zur Übersicht',
  'Common.BackToVisitDetails': 'Zurück zu den Besuchsdetails',
  'Common.Cancel': 'Abbrechen',
  'Common.ConfirmationPasswordError': 'Die von Ihnen eingegebenen Passwörter stimmen nicht überein',
  'Common.ConfirmationPasswordSecureRule': 'Ihr Passwort ist nicht sicher. Bitte achten Sie darauf, dass es mindestens 8 Zeichen besteht.',
  'Common.DateRange.LastMonth': 'Im vergangenen Monat',
  'Common.DateRange.LastSixMonths': 'Letzte 6 Monate',
  'Common.DateRange.LastTwelveMonths': 'Letzte 12 Monate',
  'Common.DateRange.LastWeek': 'Letzte Woche',
  'Common.DateRange.SpecificDate': 'Bestimmtes Datum',
  'Common.DateRange.Today': 'Heute',
  'Common.DiscardChanges': 'Sind Sie sicher das Sie die Aktion abbrechen wollen? Ihre eingegebenen Daten können verloren gehen.',
  'Common.Download': 'Download',
  'Common.Downloads': 'Downloads',
  'Common.Email.Invalid': 'Bitte geben Sie eine gültige E-Mail Adresse an',
  'Common.EndDate': 'Endtermin',
  'Common.EntryPage': 'Einstiegsseite',
  'Common.ExitPage': 'Seite verlassen',
  'Common.Exporting': 'Exportiere',
  'Common.Field.Required': 'Dieses Feld wird benötigt',
  'Common.Field.RequiredAndNumber': 'Das Feld ist erforderlich und muss eine Zahl sein',
  'Common.InvalidToken': 'Dein token ist abgelaufen.',
  'Common.InvalidTokenOrEmail': 'Es ist keine solche E-Mail in der Datenbank vorhanden oder Ihr Token ist abgelaufen.',
  'Common.Languages.Name.de': 'Deutsch',
  'Common.Languages.Name.en': 'Englisch',
  'Common.LastExport': 'Letzter Export',
  'Common.LoadMore': 'Mehr laden',
  'Common.More': 'Mehr',
  'Common.NA': 'N/A',
  'Common.NewExport': 'Neuen Export starten',
  'Common.NewImport': 'Importieren {fileName}',
  'Common.SelectFile': 'Datei auswählen',
  'Common.NextPage': 'Nächste Seite',
  'Common.No': 'Nein',
  'Common.NoData': 'Keine Daten',
  'Common.NotFound': 'Nichts Gefunden',
  'Common.Or': 'oder',
  'Common.Outlinks': 'Links außerhalb',
  'Common.Paginator.Total': 'Anzeige von {from} bis {to} von {total} Einträgen',
  'Common.PreviousPage': 'Vorherige Seite',
  'Common.Remove': 'Entfernen',
  'Common.Roles.Admin': 'Verwalter',
  'Common.Roles.Editor': 'Herausgeber',
  'Common.Roles.Viewer': 'Zuschauer',
  'Common.Save': 'Speichern',
  'Common.Search': 'Suche',
  'Common.SearchHere': 'Suche hier',
  'Common.Select.NotFoundContent': 'Keine Einträge gefunden',
  'Common.StartDate': 'Anfangsdatum',
  'Common.Success': 'Erfolgreich',
  'Common.Time': 'Zeit',
  'Common.TotalTimeOnPage': 'Gesamtzeit auf dieser Seite',
  'Common.TotalTimeOnVisit': 'Gesamtzeit bei Besuch',
  'Common.Unknown': 'Unbekannt',
  'Common.Yes': 'Ja',
  'Component.AccountSettings.Add.Success.Text': 'Das Konto wurde erfolgreich erstellt',
  'Component.AccountSettings.DuplicatedPairUserRole': 'Die Kombination der Rollen und der Benutzer sollte individuell sein.',
  'Component.AccountSettings.Edit.DeleteDomain': 'Domain entfernen',
  'Component.AccountSettings.Edit.Success.Text': 'Das Konto wurde erfolgreich geändert',
  'Component.AccountSettings.Edit.Title': 'Account bearbeiten',
  'Component.AccountSettings.List.Action.Create': 'Neue Domain',
  'Component.AccountSettings.List.Description1': 'Pflegen Sie hier Ihre Accounts und deren Inhalte.',
  'Component.AccountSettings.List.Description2': 'Bei Bedarf können Sie auch weitere hinzufügen.',
  'Component.AccountSettings.List.Title': 'Account Einstellungen',
  'Component.AccountSettings.List.SearchPlaceholder': 'Suche nach Kontonamen',
  'Component.AccountSettings.MatomoConfigurations': 'Matomokonfigurationen',
  'Component.AccountSettings.New.AvailableRoles.Title': 'Verfügbare Rollen:',
  'Component.AccountSettings.New.Description.Title': 'Neuen Account hinzufügen',
  'Component.AccountSettings.New.Domain.Save': 'Domain speichern',
  'Component.AccountSettings.New.DomainSection.MatomoDomainName': 'Domain name',
  'Component.AccountSettings.New.DomainSection.MatomoProjectName': 'Projektname',
  'Component.AccountSettings.New.DomainSection.MatomoIdName': 'website ID',
  'Component.AccountSettings.New.DomainSection.MatomoTimezone': 'Domain zeitzone',
  'Component.AccountSettings.New.DomainSection.Name': 'Domain-Name',
  'Component.AccountSettings.New.DomainSection.TestMatomoId': 'Testen Sie die Matomo-Website-ID',
  'Component.AccountSettings.New.DomainSection.Title': 'Domain',
  'Component.AccountSettings.New.Project.Name': 'Projektname',
  'Component.AccountSettings.New.Info1': 'Fügen Sie eine neue Domain hinzu, indem Sie',
  'Component.AccountSettings.New.Info2': 'Sie können aber auch den Benutzern Rechte zu Ihren Domains geben.',
  'Component.AccountSettings.New.InfoList1': 'den Domain-Namen hinzufügen',
  'Component.AccountSettings.New.InfoList2': 'Ihre Module auswählen',
  'Component.AccountSettings.New.InfoList3': 'Benutzer und deren Rechte hinzufügen.',
  'Component.AccountSettings.New.ModulesSection.Title': 'Module',
  'Component.AccountSettings.New.DomainSection.AllowedDomains': 'Zulässige Domains',
  'Component.AccountSettings.New.DomainSection.AddDomain': 'Domain hinzufügen',
  'Component.AccountSettings.New.DomainSection.AddDomain.ValidationMessage': 'Bitte geben Sie einen gültigen Domainnamen ein oder entfernen Sie das Feld',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Admin': '- Admin      = Hat vollen Zugriff auf die ihm zur Verfügung gestellten Konten',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Editor': '- Editor    = Kann kostenlose Accounts zulassen',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Editor.Span': 'Elemente ändern *',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.SuperAdmin': '- Superadmin = Kontoinhaber, hat vollen Zugriff auf alle Konten',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Viewer': '- Viewer     = Kann kostenlose Accounts zulassen',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Viewer.Span': 'Siehe Artikel *, aber nicht ändern',
  'Component.AccountSettings.New.Title': 'Neue Domain hinzufügen',
  'Component.AccountSettings.New.Title1': 'Neuen Account hinzufügen',
  'Component.AccountSettings.New.UserSection.AddUser': 'Benutzer hinzufügen',
  'Component.AccountSettings.New.UserSection.Role': 'Rolle',
  'Component.AccountSettings.New.UserSection.Title': 'Benutzer',
  'Component.AccountSettings.New.UserSection.User': 'Benutzer',
  'Component.AccountSettings.New.AccountSection.Account': 'Konto',
  'Component.AccountSettings.New.MatomoSection.Matomo': 'Matomo Konfiguration',
  'Component.AccountSettings.Overview.Info1': 'Pflegen Sie hier Ihre Accounts und deren Inhalte.',
  'Component.AccountSettings.Overview.Info2': 'Bei Bedarf können Sie auch weitere hinzufügen.',
  'Component.AccountSettings.Overview.NewDomainBtn': 'Neue Domain',
  'Component.AccountSettings.Overview.Title': 'Account-Übersicht',
  'Component.AccountSettings.RegenerateToken': 'Zugangs-Token neu generieren',
  'Component.AccountSettings.RegenerateTokenModal.Text': 'Sind Sie sicher? Der neu generierte Token muss anschließend für alle in diesem Account verbundenen Integrationen geändert werden.',
  'Component.AccountSettings.Remove.Modal.Description': 'Möchten Sie diese Domain wirklich entfernen "{projectName}"?',
  'Component.AccountSettings.Remove.Success.Text': 'Die Domain wurde erfolgreich entfernt.',
  'Component.AccountSettings.TokenModal.Text': 'Hier ist Ihr Zugangs-Token zur Website-Integration',
  'Component.AccountSwitcher.Modal.Description': 'Sie möchten in das Konto "{accountName}" wechseln. Alle nicht gespeicherten Daten gehen verloren. Möchten Sie fortfahren?',
  'Component.AccountSwitcher.Switched': 'Konto erfolgreich gewechselt',
  'Component.AdWords.List.Title': 'AdWords',
  'Component.Branches.Change.Description1': 'Bearbeiten Sie eine Branchengruppe, indem Sie einen Namen vergeben und die entsprechenden Gruppen hinzufügen.',
  'Component.Branches.Change.Description2': 'Unter den Hauptgruppen befinden sich jeweils differenziertere Untergruppen. Diese können Sie auch einzeln anhand der Checkbox auswählen.',
  'Component.Branches.Change.Form.AddTranslation': 'Übersetzung hinzufügen',
  'Component.Branches.Change.Form.Cancel': 'abbrechen',
  'Component.Branches.Change.Form.Delete': 'Branche entfernen',
  'Component.Branches.Change.Form.DownloadBranches': 'Download Standard-Branchen als xls',
  'Component.Branches.Change.Form.IndustryName': 'Branchen-Name',
  'Component.Branches.Change.Form.Submit': 'Speichern',
  'Component.Branches.Change.Form.TgTitle': 'Branchen-Auswahl',
  'Component.Branches.Change.Modal.Info': 'Die Branche wurde erfolgreich erstellt.',
  'Component.Branches.Change.Modal.Ok': 'Zur Branchen-Übersicht',
  'Component.Branches.Change.Title': 'Branche bearbeiten',
  'Component.Branches.Edit.Success.Text': 'Ihre Änderungen wurden erfolgreich gespeichert.',
  'Component.Branches.KompassCodes.ExportFinished': 'Export von standard branchens als xls abgeschlossen',
  'Component.Branches.KompassCodes.MainBranch': 'Haupt-Branchen',
  'Component.Branches.KompassCodes.SelectedBranch': 'Ihre Branchen-Auswahl',
  'Component.Branches.KompassCodes.SubBranch': 'Unter-Branchen',
  'Component.Branches.KompassCodes.Title': 'Wählen Sie eine Branche',
  'Component.Branches.KompassCodes.ValidationMessage': 'Es muss mindestens eine Branche ausgewählt werden',
  'Component.Branches.List.Create': 'Neue Branche hinzufügen',
  'Component.Branches.List.Description1': 'Hier finden Sie alle Ihre angelegten Branchen.',
  'Component.Branches.List.Description2': 'Bitte beachten Sie, dass jede Änderung einer bereits verwendeten Branche Einfluss auf Ihre Daten hat!',
  'Component.Branches.List.SearchByName': 'Geben Sie einen Namen ein, um nach einer Branche zu suchen',
  'Component.Branches.List.Title': 'Branchen Verwaltung',
  'Component.Branches.Modal.Description': 'Möchten Sie diese Branche wirklich entfernen?',
  'Component.Branches.New.Description1': 'Erstellen Sie eine neue Branchengruppe, indem Sie einen Namen vergeben und die entsprechenden Gruppen hinzufügen.',
  'Component.Branches.New.Description2': 'Unter den Hauptgruppen befinden sich jeweils differenziertere Untergruppen. Diese können Sie auch einzeln anhand der Checkbox auswählen.',
  'Component.Branches.New.Form.AddTranslation': 'Übersetzung hinzufügen',
  'Component.Branches.New.Form.Cancel': 'abbrechen',
  'Component.Branches.New.Form.DownloadBranches': 'Download Standard-Branchen als xls',
  'Component.Branches.New.Form.IndustryName': 'Branchen-Name',
  'Component.Branches.New.Form.Submit': 'Speichern',
  'Component.Branches.New.Form.TgTitle': 'Branchen-Auswahl',
  'Component.Branches.New.Modal.Info': 'Die Branche wurde erfolgreich erstellt.',
  'Component.Branches.New.Modal.Ok': 'Zur Branchen-Übersicht',
  'Component.Branches.New.Success.Text': 'Die neue Branche wurde erfolgreich erstellt.',
  'Component.Branches.New.Title': 'Neue Branche hinzufügen',
  'Component.Branches.Remove.Success.Text': 'Die Branche wurde erfolgreich entfernt.',
  'Component.Branches.Replace': 'Branche ersetzen',
  'Component.Branches.Replace.Confirm.Text': 'Haben Sie die Branche aus allen Zielgruppen entfernt?',
  'Component.Branches.Replace.Option': 'Option',
  'Component.Branches.Replace.Option1.Text': 'Möchten Sie diese Branche überall durch eine bestimmte Branche ersetzen?',
  'Component.Branches.Replace.Option2.Text': 'Oder möchten Sie die entsprechenden Zielgruppen einzeln bearbeiten?',
  'Component.Branches.Replace.Success.Text': 'Die Branche wurde in allen entsprechenden Zielgruppen ersetzt und erfolgreich entfernt',
  'Component.Branches.Replace.Warning.Text': 'Diese Branche wird bereits in {targetGroupsCount} aktiven Zielgruppen verwendet und kann daher nicht gelöscht werden.',
  'Component.Branches.ReplaceModal.Ok': 'Ja, Branche jetzt löschen',
  'Component.Branches.Start.Create': 'Neue Branche hinzufügen',
  'Component.Branches.Start.Description1': 'Sie haben sich entschieden, eigene Branchen zu verwenden.',
  'Component.Branches.Start.Description2': 'Um Zielgruppen für den Dynamic Content anlegen zu können, müssen Sie zuerst Ihre Branchen erstellen.',
  'Component.Branches.Start.Title': 'Branchen verwalten',
  'Component.Categories.Edit.Cancel': 'Abbrechen',
  'Component.Categories.Edit.CatName': 'Kategorie Name',
  'Component.Categories.Edit.Delete': 'Kategorie entfernen',
  'Component.Categories.Edit.Error': 'Der von Ihnen gewählte Name wird bereits genutzt. Bitte versuchen Sie einen anderen.',
  'Component.Categories.Edit.Save': 'Änderungen speichern',
  'Component.Categories.Edit.Success.Text': 'Die Kategorie wurde erfolgreich aktualisiert.',
  'Component.Categories.Edit.Title': 'Kategorie: ',
  'Component.Categories.List.Action.Create': 'Neue Kategorie',
  'Component.Categories.List.Info': 'Verwalten Sie hier Ihre Kategorien.',
  'Component.Categories.List.SearchByName': 'Suchen Sie nach Kategorien',
  'Component.Categories.List.Title': 'Kategorie Verwaltung',
  'Component.Categories.Modal.Description': 'Möchten Sie die Kategorie "{categoryName}" sicher entfernen?',
  'Component.Categories.New.Cancel': 'Abbrechen',
  'Component.Categories.New.CatName': 'Kategorie Name',
  'Component.Categories.New.Description': 'Kategorie erstellen',
  'Component.Categories.New.Error': 'Der von Ihnen gewählte Name wird bereits genutzt. Bitte versuchen Sie einen anderen.',
  'Component.Categories.New.Label': 'Mit * gekennzeichnete Felder sind Pflichtfelder.',
  'Component.Categories.New.Save': 'Kategorie erstellen',
  'Component.Categories.New.Success.Text': 'Die Kategorie wurde erfolgreich erstellt.',
  'Component.Categories.New.Title': 'Neue Kategorie',
  'Component.Categories.Remove.Success.Text': 'Die Kategorie wurde erfolgreich entfernt.',
  'Component.Common.ScoringCircle.PrivateProfile': 'Privat',
  'Component.Common.ScoringCircle.PublicProfile': 'Öffentlich',
  'Component.Common.ScoringCircle.ScoreLabel': 'Score:',
  'Component.Company.CreateButton': 'Neues Unternehmen',
  'Component.Company.Item.AddTitle': 'Firma hinzufügen',
  'Component.Company.Item.Attribute': 'Attribut hinzufügen',
  'Component.Company.Item.DeleteCompany': 'Firma entfernen',
  'Component.Company.Item.EditTitle': 'Firma bearbeiten',
  'Component.Company.Item.LeadLabel': 'Lead Label hinzufügen',
  'Component.Company.Item.MandatoryLabel': 'Felder mit * sind Pflichtfelder',
  'Component.Company.Item.Name': 'Unternehmens-Name',
  'Component.Company.Item.CustomerNumber': 'Kundennummer',
  'Component.Company.Item.ResetChanges': 'abbrechen',
  'Component.Company.Item.Save': 'Änderungen speichern',
  'Component.Company.Item.Success.Text': 'Die Firma wurde erfolgreich aktualisiert.',
  'Component.Company.List.SearchByName': 'Geben Sie einen Namen ein, um nach einer Firma zu suchen',
  'Component.Company.List.Title': 'Firmen-Liste',
  'Component.Company.Modal.Delete.Description': 'Möchten Sie die Firma wirklich entfernen?',
  'Component.Company.Remove.Success.Text': 'Die Firma wurde erfolgreich entfernt.',
  'Component.Company.Update.Success.Text': 'Die Firma wurde erfolgreich aktualisiert.',
  'Component.Campaigns.List.Title': 'Liste der Kampagnen',
  'Component.Campaigns.Item.Edit': 'Kampagne bearbeiten',
  'Component.Campaigns.Create': 'Neue Kampagne',
  'Component.Campaign.Item.Label': 'Label',
  'Component.Campaign.Item.Key': 'Schlüssel',
  'Component.Campaign.Item.Name': 'Name',
  'Component.Campaigns.List.SearchPlaceholder': 'Geben Sie eine Bezeichnung ein, um nach einer Kampagne zu suchen',
  'Component.Campaigns.New.Success.Text': 'Die Kampagne wurde erfolgreich hinzugefügt',
  'Component.Campaigns.Update.Success.Text': 'Die Kampagne wurde erfolgreich aktualisiert',
  'Component.Campaigns.Remove.Success.Text': 'Die Kampagne wurde erfolgreich entfernt',
  'Component.Campaigns.Modal.Description': 'Möchten Sie die Kampagne wirklich entfernen "{campaignName}"?',
  'Component.CountryRegions.Create': 'Neue Ländergruppe',
  'Component.CountryRegions.Description': 'Verwalten Sie Ihre Ländergruppen und erstellen Sie bei Bedarf neue',
  'Component.CountryRegions.Edit.Success.Text': 'Die Ländergruppe wurde erfolgreich aktualisiert.',
  'Component.CountryRegions.Form.Countries': 'Länder',
  'Component.CountryRegions.Form.Edit': 'Ländergruppe bearbeiten',
  'Component.CountryRegions.Form.Name': 'Gruppe',
  'Component.CountryRegions.Form.Title.Edit': 'Ländergruppe bearbeiten',
  'Component.CountryRegions.Form.Title.New': 'Neue Ländergruppe erstellen',
  'Component.CountryRegions.Form.New': 'Neue Ländergruppe',
  'Component.CountryRegions.List.SearchByNamePlaceholder': 'Geben Sie einen Namen ein, um nach einer Ländergruppe zu suchen',
  'Component.CountryRegions.Modal.Description': 'Möchten Sie Country Region wirklich entfernen? "{countryRegionName}"?',
  'Component.CountryRegions.New.Success.Text': 'Die Ländergruppe wurde erfolgreich erstellt.',
  'Component.CountryRegions.Remove.Success.Text': 'Die Ländergruppe wurde erfolgreich entfernt.',
  'Component.CountryRegions.Title': 'Ländergruppen Verwaltung',
  'Component.CountryRegions.Validation.Countries': 'Bitte geben Sie die Länder ein',
  'Component.CountryRegions.Validation.Name': 'Bitte geben Sie den Namen der Gruppe ein',
  'Component.Dashboard.ChangePassword': 'Passwort ändern',
  'Component.Dashboard.WelcomeMessage': 'Willkommen',
  'Component.DynamicContent.Branches.Button': 'Neue Branche hinzufügen',
  'Component.DynamicContent.Branches.Desc1': 'Sie haben sich entschieden, eigene Branchen zu verwenden.',
  'Component.DynamicContent.Branches.Desc2': 'Um Zielgruppen für den Dynamic Content anlegen zu können, müssen Sie zuerst Ihre Branchen erstellen.',
  'Component.DynamicContent.CreateButton': 'Neue Zielgruppe',
  'Component.DynamicContent.First.Button': 'Zielgruppe erstellen',
  'Component.DynamicContent.Overview.Description': 'Hier haben Sie eine Übersicht über alle Ihre gespeicherten Zielgruppen, die Sie in Ihrem TYPO3 mit dynamischen Inhalten verknüpfen können',
  'Component.DynamicContent.Overview.ModalRemove.Description': 'Möchten Sie diese Zielgruppe wirklich entfernen?',
  'Component.DynamicContent.Overview.ModalRemove.Title': 'ACHTUNG!',
  'Component.DynamicContent.Title': 'Dynamic Content',
  'Component.Industries.List.Title': 'Branchen verwalten',
  'Component.LeadDetails.Address': 'Adresse',
  'Component.LeadDetails.AllVisits': 'Alle Besuche',
  'Component.LeadDetails.Branch': 'Branches',
  'Component.LeadDetails.BranchOfIndustry': 'Branche',
  'Component.LeadDetails.Campaign': 'Kampagne',
  'Component.LeadDetails.ClassificationCodes': 'Classification Codes',
  'Component.LeadDetails.CompanyDetails': 'Firmendetails',
  'Component.LeadDetails.Date': 'Datum',
  'Component.LeadDetails.Details': 'Einzelheiten',
  'Component.LeadDetails.Domain': 'Domain',
  'Component.LeadDetails.Duration': 'Dauer',
  'Component.LeadDetails.EmployeesCount': 'Mitarbeiterzahl',
  'Component.LeadDetails.LeadMarks': 'Lead Labels',
  'Component.LeadDetails.LoadMore': 'Mehr laden',
  'Component.LeadDetails.Pages': 'Seiten',
  'Component.LeadDetails.SetMarks': 'Geben Sie einen Namen ein, um nach einem Lead Label zu suchen',
  'Component.LeadDetails.ShowAll': 'Alle Ergebnisse anzeigen',
  'Component.LeadDetails.SocialMedia': 'Socialmedia',
  'Component.LeadDetails.Source': 'Quelle',
  'Component.LeadDetails.TotalVisits': 'Anzahl der Besuche',
  'Component.LeadDetails.VisitsCount': 'Gesamtzahl der Besuche',
  'Component.LeadDetails.Website': 'Website',
  'Component.LeadLabels.Change.Description': 'Lead Label bearbeiten',
  'Component.LeadLabels.Change.Form.Cancel': 'abbrechen',
  'Component.LeadLabels.Change.Form.Delete': 'Lead Label entfernen',
  'Component.LeadLabels.Change.Form.Submit': 'Änderungen speichern',
  'Component.LeadLabels.Change.Title': 'Lead Label bearbeiten',
  'Component.LeadLabels.Edit.Success.Text': 'Das Lead Label wurde erfolgreich aktualisiert.',
  'Component.LeadLabels.Form.AddTranslation': 'Übersetzung hinzufügen',
  'Component.LeadLabels.Form.Label.Name': 'Name',
  'Component.LeadLabels.List.Action.Create': 'Neues Lead Label',
  'Component.LeadLabels.List.Info': 'Verwalten Sie hier Ihre Lead Labels und erstellen sie bei Bedarf neue.',
  'Component.LeadLabels.List.SearchByNamePlaceholder': 'Suchen Sie nach Lead-Labels',
  'Component.LeadLabels.List.Title': 'Lead Labels Management',
  'Component.LeadLabels.New.Description': 'Lead Label erstellen',
  'Component.LeadLabels.New.Form.Submit': 'Lead Label erstellen',
  'Component.LeadLabels.New.Success.Text': 'Neues Lead Label wurde erfolgreich erstellt.',
  'Component.LeadLabels.New.Title': 'Neues Lead Label',
  'Component.LeadLabels.Remove.Modal.Description': 'Möchten Sie das Lead Label wirklich entfernen "{leadLabel}"?',
  'Component.LeadLabels.Remove.Success.Text': 'Das Lead Label wurde erfolgreich entfernt.',
  'Component.Leads.CompaniesList.Title': 'Lead Management - Firmen',
  'Component.Leads.CompaniesList.Description': 'Im Lead Management haben Sie einen Überblick über alle Ihre Unternehmen und können deren Verhalten auf Ihrer Website bewerten.',
  'Component.Leads.VisitsList.Button.Hint.Hide': 'Firma ausblenden',
  'Component.Leads.VisitsList.Button.Hint.MarkAsIsp': 'Als Provider markieren',
  'Component.Leads.VisitsList.Button.Hint.MarkAsNotIsp': 'Markierung als Provider aufheben',
  'Component.Leads.VisitsList.Button.Hint.OpenWebiste': 'Zur Website',
  'Component.Leads.VisitsList.Button.Hint.QuickView': 'Quick View',
  'Component.Leads.VisitsList.Button.Hint.TransferToHubspot': 'Übertragen in Hubspot',
  'Component.Leads.VisitsList.Button.Hint.Unhide': 'Firma einblenden',
  'Component.Leads.VisitsList.Button.Hint.ViewDetails': 'Firmen-Details',
  'Component.Leads.VisitsList.Button.Hint.VisitDetails': 'Besuch-Details',
  'Component.Leads.VisitsList.Description1': 'Mit dem Lead Management haben Sie eine Übersicht für all Ihre Besucher. Hiermit können Sie das Besucherverhalten auf Ihrer Seite bewerten.',
  'Component.Leads.VisitsList.ExportFinished': 'Export der Firmenbesuche abgeschlossen. Bitte weiter zu "Lead Management -> Besuche“ zum Download.',
  'Component.Leads.VisitsList.Title': 'Lead Management - Besuche',
  'Component.LeadScoring.Edit.Cancel': 'Abbrechen',
  'Component.LeadScoring.Edit.CatName': 'Profil',
  'Component.LeadScoring.Edit.Delete': 'Scoring Profil löschen',
  'Component.LeadScoring.Edit.Description': 'Profil Anpassen',
  'Component.LeadScoring.Edit.Error': 'Der von Ihnen gewählte Profilname ist bereits vergeben. Bitte wählen Sie einen anderen.',
  'Component.LeadScoring.Edit.Label': 'Felder mit * sind Pflichtfelder',
  'Component.LeadScoring.Edit.Save': 'Änderungen speichern',
  'Component.LeadScoring.Edit.Success.Text': 'Das Scoring Profil wurde erfolgreich aktualisiert.',
  'Component.LeadScoring.Edit.Title': 'Lead Scoring: ',
  'Component.LeadScoring.Field.Attribute.ClassificationCodes.Placeholder': 'Suchen Sie nach LXP-Standard Branchen',
  'Component.LeadScoring.Form.AddCondition': 'Bedingung hinzufügen',
  'Component.LeadScoring.Form.Assertion': 'Bedingung',
  'Component.LeadScoring.Form.Attribute': 'Attribute Set {set}',
  'Component.LeadScoring.Form.Condition': 'Beziehung',
  'Component.LeadScoring.Form.Connector': 'Connector',
  'Component.LeadScoring.Form.DeleteAttribute.Hint': 'Attribute Set entfernen',
  'Component.LeadScoring.Form.Enabled': 'Aktiviert',
  'Component.LeadScoring.Form.LogicalOperator': 'Operator',
  'Component.LeadScoring.Form.ProfileScore': 'Score',
  'Component.LeadScoring.Form.Public': 'Öffentlich',
  'Component.LeadScoring.Form.PublicDisabledOnEditHint': 'Die Sichtbarkeit des Scoring Profils darf nicht geändert werden.',
  'Component.LeadScoring.Form.ShortDescription': 'Beschreibung',
  'Component.LeadScoring.Form.TestAttribute.Hint': 'Besuche anzeigen, die mit dem Attribut übereinstimmen. Die Tabelle zeigt bis zu 1000 letzte Besuche.',
  'Component.LeadScoring.Form.TestingPeriod': 'Test Zeitraum',
  'Component.LeadScoring.Form.TestPeriod': 'Letzte {days} Tage',
  'Component.LeadScoring.Form.TestProfile': 'Profil testen',
  'Component.LeadScoring.Form.TestProfile.Hint': 'Besuche anzeigen, die mit dem Scoringprofil übereinstimmen. Die Tabelle zeigt bis zu 1000 letzte Besuche.',
  'Component.LeadScoring.Form.Type': 'Typ',
  'Component.LeadScoring.Form.Value': 'Wert',
  'Component.LeadScoring.Form.Value.Duration': 'Wert (sekunden)',
  'Component.LeadScoring.Grid.LastChanged': 'Zuletzt geändert',
  'Component.LeadScoring.Grid.ProfileName': 'Name',
  'Component.LeadScoring.Grid.User': 'Benutzer',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.and': 'und',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.Is': 'Ist',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.Not': 'Ist nicht',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.or': 'oder',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.contains': 'beinhaltet',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.ends_with': 'endet mit',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.eq': 'gleich',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.gte': 'größer oder gleich',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.lte': 'kleiner oder gleich',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.range': 'Bereich',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.regexp': 'Regexp',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.starts_with': 'beginnt mit',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.branch': 'Kundenspezifische Branchen',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.classification_code': 'LXP-Standard Branchen',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.company_pattern': 'Firmenname',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.company_size': 'Firmengröße',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.country': 'Land',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.country_group': 'Ländergruppe',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.duration': 'Verweildauer',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.email_click': 'Email Klick',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.file_download': 'Datei Herunterladung',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.form_submit': 'Formular Absendung',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.lead_label': 'Lead Label',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.page_group': 'Seitengruppe',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.phone_click': 'Telefon Klick',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.referrer': 'Referrer Url',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.returned_visitor': 'Anzahl wiederkehrender Besuche',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.source': 'Quelle',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.zip_code': 'Postleitzahl',
  'Component.LeadScoring.List.Filter.All': 'Alle Scoring Profile',
  'Component.LeadScoring.List.Private': 'Privates Scoring Profile',
  'Component.LeadScoring.List.Profile.Create': 'Neues Scoring Profil',
  'Component.LeadScoring.List.Profile.Edit': 'Scoring Profil bearbeiten',
  'Component.LeadScoring.List.Profile.Info': 'Verwalten Sie hier Ihre Scoring-Profil',
  'Component.LeadScoring.List.Public': 'Öffentliches Scoring Profile',
  'Component.LeadScoring.List.SearchByNamePlaceholder': 'Suchen Sie nach Scoring Profilen',
  'Component.LeadScoring.Modal.Description': 'Wollen Sie das Scoring Profil: "{profileName}" sicher löschen?',
  'Component.LeadScoring.New.Cancel': 'Abbrechen',
  'Component.LeadScoring.New.CatName': 'Profil',
  'Component.LeadScoring.New.Description': 'Erstellen Sie eine neues Scoring Profil.',
  'Component.LeadScoring.New.Error': 'Dieser Name wird schon genutzt',
  'Component.LeadScoring.New.Save': 'Scoring Profil anlegen.',
  'Component.LeadScoring.New.Success.Text': 'Das Scoring Profil wurde erfolgreich erstellt.',
  'Component.LeadScoring.New.Title': 'Neues Scoring Profil anlegen.',
  'Component.LeadScoring.Remove.Success.Text': 'Das Scoring Profil wurde erfolgreich gelöscht.',
  'Component.LeadsVisitsFilter.Advanced': 'Erweitert',
  'Component.LeadsVisitsFilter.Branch': 'Nach Branche filtern',
  'Component.LeadsVisitsFilter.Campaign': 'Nach Kampagnen-Keyword filtern',
  'Component.LeadsVisitsFilter.CampaignName': 'Nach Kampagnen-Name filtern',
  'Component.LeadsVisitsFilter.ClearAllFilters': 'Filter zurücksetzen',
  'Component.LeadsVisitsFilter.CompanyName': 'Nach Firmen filtern',
  'Component.LeadsVisitsFilter.CompanyNameSearch': 'Nach Firmennamen filtern',
  'Component.LeadsVisitsFilter.CustomerNumberSearch': 'Nach Kundennummer filtern',
  'Component.LeadsVisitsFilter.CompanyVisibility.All': 'Alle anzeigen',
  'Component.LeadsVisitsFilter.CompanyVisibility.Filtered': 'Gefilterte anzeigen',
  'Component.LeadsVisitsFilter.CompanyVisibility.Hidden': 'Show hidden',
  'Component.LeadsVisitsFilter.CompanyVisibility.Visible': 'Sichtbare anzeigen',
  'Component.LeadsVisitsFilter.CompanyVisibilityPlaceholder': 'Nach Firmen-Sichtbarkeit filtern',
  'Component.LeadsVisitsFilter.Country': 'Nach Land filtern',
  'Component.LeadsVisitsFilter.City': 'Nach Stadt filtern',
  'Component.LeadsVisitsFilter.FilterAndSort': 'Filtern und sortieren',
  'Component.LeadsVisitsFilter.HideAdvanced': 'Verbergen erweitert',
  'Component.LeadsVisitsFilter.Label': 'Lead Label',
  'Component.LeadsVisitsFilter.LessFilters': 'Weniger Filter',
  'Component.LeadsVisitsFilter.Period': 'Zeitraum',
  'Component.LeadsVisitsFilter.Score': 'Nach Score filtern',
  'Component.LeadsVisitsFilter.ScoringAll': 'Lead Score',
  'Component.LeadsVisitsFilter.ScoringNoScore': 'Kein Score',
  'Component.LeadsVisitsFilter.ScoringProfiles': 'Nach Scoringprofil filtern',
  'Component.LeadsVisitsFilter.ScoringProfilesAll': 'Lead Score',
  'Component.LeadsVisitsFilter.ScoringProfilesPrivate': 'Privat',
  'Component.LeadsVisitsFilter.ScoringProfilesPublic': 'Öffentlich',
  'Component.LeadsVisitsFilter.ScoringProfilesVisibilityPlaceholder': 'Nach Scoringprofil-Sichtbarkeit filtern',
  'Component.LeadsVisitsFilter.ShowHidden': 'Zeige versteckt',
  'Component.LeadsVisitsFilter.ShowISP': 'Zeige ISP',
  'Component.LeadsVisitsFilter.ShowKompassBranches': 'Klassifizierungscodes anzeigen',
  'Component.LeadsVisitsFilter.Source': 'Nach Quelle filtern',
  'Component.LeadsVisitsFilter.HubspotTask': 'Nach HubSpot-Status filtern',
  'Component.LeadsVisitsFilter.HubspotTask.ValueAll': 'Alle anzeigen',
  'Component.LeadsVisitsFilter.HubspotTask.ValueHasTask': 'Verarbeitet',
  'Component.LeadsVisitsFilter.HubspotTask.ValueNoTask': 'Offen',
  'Component.LeadsVisitsFilter.HubspotTask.Pending': 'Ausstehend',
  'Component.NavMenu.Companies': 'Firmen',
  'Component.NavMenu.Companies.Attributes': 'Attribute',
  'Component.NavMenu.Companies.Overview': 'Unternehmensattribute',
  'Component.NavMenu.Campaigns.Overview': 'Kampagnen',
  'Component.NavMenu.DynamicContent': 'Dynamischer Inhalt',
  'Component.NavMenu.LeadManagement': 'Lead Management',
  'Component.NavMenu.LeadManagement.AllVisitDetailsTitle': 'Besuchen Sie Details',
  'Component.NavMenu.LeadManagement.AllVisitsTitle': 'Lead Management - Alle Besuche',
  'Component.NavMenu.LeadManagement.Companies': 'Firmen',
  'Component.NavMenu.LeadManagement.PageDetailsTitle': '- Besuchen Sie Details: Seitendetails',
  'Component.NavMenu.LeadManagement.SessionRecording': 'Sitzungsaufzeichnung',
  'Component.NavMenu.LeadManagement.Visits': 'Besuche',
  'Component.NavMenu.Logout': 'Ausloggen',
  'Component.NavMenu.Settings': 'Einstellungen',
  'Component.PageGroups.Create': 'Neue Seitengruppe',
  'Component.PageGroups.Description': 'Verwalten Sie Ihre Seitengruppen und erstellen Sie bei Bedarf neue',
  'Component.PageGroups.Form.Add': 'URL-Set hinzufügen',
  'Component.PageGroups.Form.Edit': 'Seitengruppe bearbeiten',
  'Component.PageGroups.Form.Name': 'Seitengruppe',
  'Component.PageGroups.Form.New': 'Neue Seitengruppe',
  'Component.PageGroups.Form.Operator': 'Operator',
  'Component.PageGroups.Form.Value': 'Wert',
  'Component.PageGroups.List.Label': 'Seitengruppen Managemant',
  'Component.PageGroups.List.SearchByNamePlaceholder': 'Geben Sie einen Namen ein, um nach Seitengruppen zu suchen',
  'Component.PageGroups.Modal.Description': 'Möchten Sie die Seitengruppe wirklich entfernen? \'{pageGroupName}\' ?',
  'Component.PageGroups.Operator.contains': 'Enthält',
  'Component.PageGroups.Operator.ends_with': 'Endet mit',
  'Component.PageGroups.Operator.eq': 'Gleich',
  'Component.PageGroups.Operator.regexp': 'Regexp Pattern',
  'Component.PageGroups.Operator.starts_with': 'Startet mit',
  'Component.PageGroups.Title': 'Seitengruppen',
  'Component.PageGroups.URLset': 'URL-Set',
  'Component.PageGroups.Validation.Name': 'Bitte geben Sie den Namen der Seitengruppe ein',
  'Component.PageGroups.Validation.Operator': 'Bitte geben Sie den Namen des Operators ein',
  'Component.PageGroups.Validation.Value': 'Bitte geben Sie den Wert ein',
  'Component.Settings.LeadLabels.Label': 'Lead Label Verwaltung',
  'Component.Settings.LeadScoring.List.Label': 'Lead Scoring',
  'Component.Sider.Trigger': 'Seitenleiste minimieren',
  'Component.TargetGroup.Branches.AvailableBranches': 'Verfügbare Branchen',
  'Component.TargetGroup.LeadLabel.Title': 'Lead Label',
  'Component.TargetGroup.Branches.Description': 'Bitte wählen Sie die entsprechende Branche aus.',
  'Component.TargetGroup.Branches.NoItems': 'Keine Auswahl',
  'Component.TargetGroup.Branches.Search': 'Branchen suchen',
  'Component.TargetGroup.Branches.SelectedBranches': 'Ausgewählte Branchen',
  'Component.TargetGroup.Branches.Title': 'Branchen',
  'Component.TargetGroup.Branches.ValidationMessage': 'Mindestens eine Branche muss ausgewählt werden',
  'Component.TargetGroup.Change.Description': 'Möchten Sie die Einstellungen dieser Zielgruppe ändern?',
  'Component.TargetGroup.Change.Form.AddCampaign': 'Kampagne anlegen',
  'Component.TargetGroup.Change.Form.AddCountry': 'weiteres Land',
  'Component.TargetGroup.Change.Form.Campaign': 'Kampagne',
  'Component.TargetGroup.Change.Form.CampaignAdGroup': 'Anzeigengruppe',
  'Component.TargetGroup.Change.Form.CampaignInfo': 'Um Ihre Kampagnen hinzuzufügen, verlinken Sie Ihre',
  'Component.TargetGroup.Change.Form.CampaignMandatoryLabel': 'Felder mit * sind Pflichtfelder.',
  'Component.TargetGroup.Change.Form.CampaignTitle': 'Kampagne',
  'Component.TargetGroup.Change.Form.Cancel': 'Änderungen verwerfen',
  'Component.TargetGroup.Change.Form.Category': 'Kategorie',
  'Component.TargetGroup.Change.Form.CompSize': 'Unternehmensgröße',
  'Component.TargetGroup.Change.Form.Country': 'Land',
  'Component.TargetGroup.Change.Form.Delete': 'Zielgruppe löschen',
  'Component.TargetGroup.Change.Form.DownloadBranches': 'Download Standard-Branchen als xls',
  'Component.TargetGroup.Change.Form.Error': 'Dieses Feld wird benötigt',
  'Component.TargetGroup.Change.Form.New.Category': 'Neue Kategorie',
  'Component.TargetGroup.Change.Form.Save': 'Änderungen speichern',
  'Component.TargetGroup.Change.Form.ShortDesc': 'Kurzbeschreibung',
  'Component.TargetGroup.Change.Form.TargetGroupActive': 'Zielgruppe aktivieren',
  'Component.TargetGroup.Change.Form.TargetGroupName': 'Zielgruppen-Name',
  'Component.TargetGroup.Change.Modal.Info': 'Ihre Änderungen wurden erfolgreich gespeichert.',
  'Component.TargetGroup.Change.Modal.Ok': 'Zur Zielgruppen-Übersicht',
  'Component.TargetGroup.Change.Title': 'Zielgruppe bearbeiten',
  'Component.TargetGroup.ClassificationCodes.Title': 'Klassifizierungscodes',
  'Component.TargetGroup.Copy.Success': 'Die Zielgruppe wurde erfolgreich kopiert.',
  'Component.TargetGroup.Edit.Success': 'Die Zielgruppe wurde erfolgreich ersetzt',
  'Component.TargetGroup.From': 'Von',
  'Component.TargetGroup.List.SearchByName': 'Suchen Sie nach Dynamischen Content Gruppen',
  'Component.TargetGroup.List.FilterByCategory': 'Nach Kategorie Filtern',
  'Component.TargetGroup.Modal.Remove.Description': 'Möchten Sie diese Zielgruppe wirklich entfernen?',
  'Component.TargetGroup.Modal.Remove.Title': 'ACHTUNG!',
  'Component.TargetGroup.New.Description1': 'Legen Sie hier die Zielgruppen an, welche Sie anschließend in TYPO3 mit dem dynamischen Content verknüpfen können.',
  'Component.TargetGroup.New.Description2': 'Für eine bessere Übersichtlichkeit können Sie eine Kurzbeschreibung vergeben.',
  'Component.TargetGroup.New.Description3': 'Für eine schnellere optische Zuordnung vergeben Sie eine Kategorie.',
  'Component.TargetGroup.New.Form.AddCampaign': 'Kampagne anlegen',
  'Component.TargetGroup.New.Form.AddCountry': 'weiteres Land',
  'Component.TargetGroup.New.Form.CampaignAdGroup': 'Anzeigengruppe',
  'Component.TargetGroup.New.Form.CampaignInfo': 'Um Ihre Kampagnen hinzuzufügen, verlinken Sie Ihren',
  'Component.TargetGroup.New.Form.CampaignMandatoryLabel': 'Felder mit * sind Pflichtfelder.',
  'Component.TargetGroup.New.Form.CampaignName': 'Kampagnen Name',
  'Component.TargetGroup.New.Form.CampaignParameter': 'Parameter',
  'Component.TargetGroup.New.Form.CampaignSave': 'Zielgruppe speichern',
  'Component.TargetGroup.New.Form.CampaignSaveTitle1': 'Sind Sie mit Ihrer Auswahl zufrieden?',
  'Component.TargetGroup.New.Form.CampaignSaveTitle2': 'Dann vergessen Sie nicht diese zu speichern.',
  'Component.TargetGroup.New.Form.CampaignTitle': 'Kampagne',
  'Component.TargetGroup.New.Form.CampaignValue': 'Wert',
  'Component.TargetGroup.New.Form.Category': 'Kategorie',
  'Component.TargetGroup.New.Form.CompSize': 'Unternehmensgröße',
  'Component.TargetGroup.New.Form.Country': 'Land',
  'Component.TargetGroup.New.Form.CountryRegions': 'Ländergruppen',
  'Component.TargetGroup.New.Form.DownloadBranches': 'Download Standard-Branchen als xls',
  'Component.TargetGroup.New.Form.Error': 'Dieses Feld wird benötigt',
  'Component.TargetGroup.New.Form.New.Category': 'Neue Kategorie',
  'Component.TargetGroup.New.Form.ShortDesc': 'Kurzbeschreibung',
  'Component.TargetGroup.New.Form.TargetGroupActive': 'Zielgruppe aktivieren',
  'Component.TargetGroup.New.Form.TargetGroupName': 'Zielgruppen-Name',
  'Component.TargetGroup.New.Success': 'Die Zielgruppe wurde erfolgreich gespeichert.',
  'Component.TargetGroup.New.Title': 'Legen Sie eine neue Zielgruppe an',
  'Component.TargetGroup.NewCategory.Description': 'Neue Kategorie erstellen',
  'Component.TargetGroup.NewCategory.Form.Cancel': 'abbrechen',
  'Component.TargetGroup.NewCategory.Form.Name': 'Kategoriename',
  'Component.TargetGroup.NewCategory.Form.Save': 'Kategorie speichern',
  'Component.TargetGroup.NewCategory.Modal.Info': 'Die Kategorie wurde erfolgreich angelegt und kann sofort angewendet werden.',
  'Component.TargetGroup.NewCategory.Modal.Ok': 'OK',
  'Component.TargetGroup.NewCategory.Title': 'Neue Kategorie',
  'Component.TargetGroup.Remove.Success': 'Die Zielgruppe wurde erfolgreich entfernt',
  'Component.TargetGroup.To': 'zu',
  'Component.User.Administration.Create': 'Neuer Benutzer',
  'Component.User.Administration.Description': 'Sie können zusätzliche Benutzer anlegen und diesen entsprechende Rechte zuweisen',
  'Component.User.Administration.Edit.Success.Text': 'Die Nutzerdaten wurden erfolgreich aktualisiert.',
  'Component.User.Administration.Modal.Description': 'Möchten Sie diesen Benutzer wirklich entfernen "{first_name} {last_name}"?',
  'Component.User.Administration.Own.Edit.Description': 'Bearbeiten Sie Ihre Benutzerdaten',
  'Component.User.Administration.Own.Edit.Title': 'Ihr Profil',
  'Component.User.Administration.Remove.Success.Text': 'Der Benutzer wurde erfolgreich entfernt.',
  'Component.User.Administration.Role': 'Sie sind',
  'Component.User.Administration.SearchByEmailPlaceholder': 'Geben Sie eine E-Mail ein um nach Benutzern zu suchen',
  'Component.User.Administration.Title': 'Benutzer Verwaltung',
  'Component.User.Administration.Users.Delete.Modal.Description': 'Möchten Sie diesen Benutzer wirklich entfernen?',
  'Component.User.Administration.Users.Delete.Modal.Title': 'ACHTUNG!',
  'Component.User.Administration.Users.Edit.AccessTitle': 'Zugriffsrechte',
  'Component.User.Administration.Users.Edit.AddAcount': 'Konto hinzufügen',
  'Component.User.Administration.Users.Edit.Avatar': 'Profilbild',
  'Component.User.Administration.Users.Edit.Cancel': 'abbrechen',
  'Component.User.Administration.Users.Edit.Delete': 'Benutzer entfernen',
  'Component.User.Administration.Users.Edit.Description': 'Hier kannst du die Einstellungen des ausgewählten Benutzers bearbeiten.',
  'Component.User.Administration.Users.Edit.Form.Account': 'Konto',
  'Component.User.Administration.Users.Edit.Form.Email': 'E-mail',
  'Component.User.Administration.Users.Edit.Form.Email2': 'Geben Sie Ihre E-mail Adresse erneut ein',
  'Component.User.Administration.Users.Edit.Form.Error': 'Dieses Feld wird benötigt',
  'Component.User.Administration.Users.Edit.Form.ErrorValid': 'Dieses Feld ist nicht gültig',
  'Component.User.Administration.Users.Edit.Form.fName': 'Vorname',
  'Component.User.Administration.Users.Edit.Form.Lang': 'Sprache',
  'Component.User.Administration.Users.Edit.Form.lName': 'Nachname',
  'Component.User.Administration.Users.Edit.Form.Password': 'Passwort',
  'Component.User.Administration.Users.Edit.Form.Password2': 'Geben Sie Ihr Passwort erneut ein',
  'Component.User.Administration.Users.Edit.Form.Role': 'Rolle',
  'Component.User.Administration.Users.Edit.MandatoryLabel': 'Felder mit * sind Pflichtfelder.',
  'Component.User.Administration.Users.Edit.Modal.Info': 'Ihre Änderungen wurden erfolgreich gespeichert',
  'Component.User.Administration.Users.Edit.Modal.Ok': 'Zurück zur Benutzerübersicht',
  'Component.User.Administration.Users.Edit.Save': 'Änderungen speichern',
  'Component.User.Administration.Users.Edit.Title': 'Benutzer bearbeiten:',
  'Component.User.Administration.Users.Edit.Title.UserName': 'Benutzername',
  'Component.User.Administration.Users.New.AccessTitle': 'Zugriffsrechte',
  'Component.User.Administration.Users.New.AddAcount': 'Konto hinzufügen',
  'Component.User.Administration.Users.New.Avatar': 'Profilbild',
  'Component.User.Administration.Users.New.Cancel': 'abbrechen',
  'Component.User.Administration.Users.New.Description': 'Legen Sie einen neuen Benutzer an und geben Sie ihm die entsprechenden Rechte.',
  'Component.User.Administration.Users.New.Form.Account': 'Konto',
  'Component.User.Administration.Users.New.Form.Email': 'E-mail',
  'Component.User.Administration.Users.New.Form.Error': 'Bitte füllen Sie dieses Feld aus',
  'Component.User.Administration.Users.New.Form.fName': 'Vorname',
  'Component.User.Administration.Users.New.Form.Lang': 'Sprache',
  'Component.User.Administration.Users.New.Form.lName': 'Nachname',
  'Component.User.Administration.Users.New.Form.Role': 'Rolle',
  'Component.User.Administration.Users.New.MandatoryLabel': 'Mit * gekennzeichnete Felder sind Pflichtfelder.',
  'Component.User.Administration.Users.New.Modal.Ok': 'Zur Benutzerverwaltung',
  'Component.User.Administration.Users.New.PersonalData': 'Persönliche Daten',
  'Component.User.Administration.Users.New.Save': 'Neuen Benutzer anlegen',
  'Component.User.Administration.Users.New.Success.Text': 'Der Benutzer wurde erfolgreich angelegt.',
  'Component.User.Administration.Users.New.Title': 'Neuen Benutzer anlegen',
  'Component.User.Administration.Users.New.SuperAdmin': 'Super Admin Erlaubnis',
  'Component.User.Administration.Users.New.SuperAdmin.Description': 'Super Admin Berechtigung, hat vollen Zugriff auf alle Konten',
  'Components.FirstLogin.Header': 'Hallo ',
  'Components.FirstLogin.PasswordConfirmError': 'Bitte bestätigen Sie Ihr Passwort',
  'Components.FirstLogin.PasswordConfirmLabel': 'Passwort wiederholen',
  'Components.FirstLogin.PasswordError': 'Bitte geben Sie Ihr Passwort ein.',
  'Components.FirstLogin.PasswordLabel': 'Neues Passwort',
  'Components.FirstLogin.PasswordMismatchError': 'Die von Ihnen eingegebenen Passwörter stimmen nicht überein',
  'Components.FirstLogin.Text.Password1': 'Min 8 Zeichen',
  'Components.FirstLogin.Text.Password2': 'Groß- und Kleinbuchstaben',
  'Components.FirstLogin.Text.Password3': "mindestens ein Sonderzeichen (!\"§$%&/()=?*+'#,;.:-_–)",
  'Components.FirstLogin.Text.Password4': 'mindestens eine Zahl zwischen 0 und 9',
  'Components.FirstLogin.Text1': 'Sie wollen sich zum ersten Mal anmelden.',
  'Components.FirstLogin.Text2': 'Bitte ändern Sie zuerst das Passwort, das Sie von uns per E-Mail erhalten haben.',
  'Components.FirstLogin.Text3': 'Vermeiden Sie dabei leicht zu erratende oder bereits verwendete Passwörter.',
  'Components.FirstLogin.Text4': 'Achten Sie dabei darauf auf folgendes:',
  'Components.FirstLogin.Text5': 'Die Stärke Ihres Passworts sehen Sie an der Skala.',
  'Components.FirstLogin.Text6': 'Sobald sich die Skala in den grünen Bereich bewegt, ist ihr Passwort ausreichend geschützt.',
  'Components.ForgotPassword.BackToLogin': 'Zurück zum login',
  'Components.ForgotPassword.BadRequest': 'E-Mail existiert nicht',
  'Components.ForgotPassword.FirstIndent': 'Eine E-Mail zum zurücksetzen Ihres Passwortes wurde an Sie versendet.',
  'Components.ForgotPassword.HeaderText': 'Passwort vergessen',
  'Components.ForgotPassword.NewPasswordRequest': 'Neues Passwort anfordern',
  'Components.ForgotPassword.SecondIndent': 'Sollten Sie keine solche E-Mail von uns erhalten haben, prüfen Sie bitte Ihren Spam-Ordner oder kontaktieren Sie uns: {supportEmail}',
  'Components.ForgotPassword.SuccessRequest': 'Die e-mail wurde erfolgreich gesendet',
  'Components.ForgotPassword.ThankYou': 'Vielen Dank!',
  'Components.LoginForm.ForgotPassword': 'Passwort vergessen?',
  'Components.LoginForm.HeaderText': 'Bitte melden Sie sich mit Ihrer E-Mail Adresse und Ihrem Passwort an.',
  'Components.LoginForm.Password.ErrorText': 'Bitte geben Sie Ihr Passwort ein',
  'Components.LoginForm.Password.Label': 'Passwort',
  'Components.LoginForm.Username.ErrorText': 'Bitte geben Sie Ihren Benutzernamen ein',
  'Components.LoginForm.Username.Label': 'Email',
  'Components.LoginForm.ValidationHint': 'Mit * gekennzeichnete Felder sind Pflichtfelder.',
  'Grid.Column.Accounts': 'Konten',
  'Grid.Column.Actions': 'Aktionen',
  'Grid.Column.Active': 'Aktiv',
  'Grid.Column.AmountOfPages': 'Anzahl der Seiten',
  'Grid.Column.AssignmentToCompanyTracker': 'Zuordnung zum Company Tracker',
  'Grid.Column.Branches': 'Branche',
  'Grid.Column.Campaign': 'Kampagne',
  'Grid.Column.Campaigns': 'Kampagnen',
  'Grid.Column.Category': 'Kategorie',
  'Grid.Column.City': 'Stadt',
  'Grid.Column.ClassificationCodes': 'Klassifizierungscodes',
  'Grid.Column.CompanyName': 'Firmenname',
  'Grid.Column.CompanySize': 'Unternehmensgröße',
  'Grid.Column.Copy': 'Kopieren',
  'Grid.Column.Country': 'Land',
  'Grid.Column.CountryRegions': 'Ländergruppen',
  'Grid.Column.Date': 'Datum',
  'Grid.Column.Delete': 'Löschen',
  'Grid.Column.Details': 'Details',
  'Grid.Column.Domain': 'Domain',
  'Grid.Column.Account': 'Konto',
  'Grid.Column.Duration': 'Dauer',
  'Grid.Column.DurationOfVisit': 'Dauer des Besuchs',
  'Grid.Column.DynamicContent': 'Dynamischer Inhalt',
  'Grid.Column.Edit': 'Bearbeiten',
  'Grid.Column.Email': 'Email',
  'Grid.Column.Event': 'Veranstaltung',
  'Grid.Column.Events': 'Veranstaltungen',
  'Grid.Column.FirstName': 'Vorname',
  'Grid.Column.ISP': 'ISP',
  'Grid.Column.LastName': 'Nachname',
  'Grid.Column.LastVisitedAt': 'Letzter Besuch',
  'Grid.Column.LastVisitedUrl': 'Letzte URL',
  'Grid.Column.LeadLabel': 'Lead Label',
  'Grid.Column.CustomerNumber': 'Kundennummer',
  'Grid.Column.Modules': 'Module',
  'Grid.Column.Name': 'Name',
  'Grid.Column.Number': 'Nummer',
  'Grid.Column.Pages': 'Seiten',
  'Grid.Column.PageTitle': 'Seitentitel',
  'Grid.Column.PageUrl': 'Seiten-URL',
  'Grid.Column.Role': 'Rolle',
  'Grid.Column.Score': 'Ergebnis',
  'Grid.Column.Status': 'Status',
  'Grid.Column.Status.Invalid': 'gültig',
  'Grid.Column.Status.Valid': 'ungültig',
  'Grid.Column.TargetGroup': 'Zielgruppe',
  'Grid.Column.Url': 'Url',
  'Grid.Column.Users': 'Benutzer',
  'Grid.Column.Value': 'Wert',
  'Grid.Column.Label': 'Label',
  'Grid.Column.Key': 'Schlüssel',
  'Grid.Column.VisitStartTimestamp': 'Anfangsdatum',
  'Grid.Column.LastVisitSource': 'Quelle',
  'Values.Leads.Type.QUALIFIED': 'Qualifiziert',
  'Values.Leads.Type.UNQUALIFIED': 'Unqualifiziert',
  'Visit.Source.ValueLabel.all': 'Alle',
  'Visit.Source.ValueLabel.campaign': 'Kampange',
  'Visit.Source.ValueLabel.direct': 'Direkt',
  'Visit.Source.ValueLabel.search': 'Suche',
  'Visit.Source.ValueLabel.social': 'Social',
  'Visit.Source.ValueLabel.website': 'Website',
  'Button.Hint.HideCompany': 'Firma ausblenden',
  'Button.Hint.UnHideCompany': 'Firma einblenden,',
  'Button.Hint.MarkIsp': 'Firma als ISP markieren',
  'Button.Hint.UnMarkIsp': 'Firma als nicht ISP markieren',
  'Component.TwoColumnsSelect.AvailableLabel': 'Elemente',
  'Component.TwoColumnsSelect.SelectedLabel': 'Ausgewählt',
  'Component.TwoColumnsSelect.SearchPlaceholder': 'Suchen',
  'Component.TwoColumnsSelect.EmptySearchResult': 'Keine Ergebnisse',
  'Component.AccountSettings.New.HubspotSection.HubspotTitle': 'Hubspot',
  'Component.AccountSettings.New.HubspotSection.SelectUsersTitle': 'Hubspot Benutzer',
  'Component.AccountSettings.New.HubspotSection.SelectUsersDescription': 'Bitte wählen Sie die Benutzer aus, die Sie von Hubspot importieren möchten.',
  'Component.AccountSettings.New.HubspotSection.ConfirmTokenUpdate': 'Möchten Sie das Token aktualisieren? Wenn das neue Token einem anderen Hubspot-Portal gehört, wird die bestehende Verbindung zwischen diesem Konto und dem Hubspot-Portal entfernt.',
  'Component.AccountSettings.New.HubspotSection.AccountIntegratedPlaceholder': 'Integriert mit Hubspot Portal "{portalId}"',
  'Component.AccountSettings.New.HubspotSection.AccountNotIntegratedPlaceholder': 'Erstellen Sie ein Private App API-Token in Hubspot und fügen Sie es hier ein',
  'Component.SearchCreateCompanyModal.Title': 'Hubspot Unternehmen',
  'Component.SearchCreateCompanyModal.Description1': 'Bitte wählen Sie ein bestehendes Unternehmen in HubSpot aus oder erstellen Sie ein neues',
  'Component.SearchCreateCompanyModal.Text.CompanyNameInLxp': 'Unternehmensname in LXP',
  'Component.SearchCreateCompanyModal.Text.CompanyNameFormLabel': 'Wählen Sie Unternehmen aus Hubspot',
  'Component.SearchCreateCompanyModal.Text.NoCompaniesFound': 'Keine Unternehmen gefunden',
  'Component.SearchCreateCompanyModal.Text.CompanyNamePlaceholder': 'Wählen Sie ein Element aus oder starten Sie die Eingabe für eine neue Suche',
  'Component.SearchCreateCompanyModal.Button.UseExistingCompany': 'Bestehendes Unternehmen verwenden',
  'Component.SearchCreateCompanyModal.Button.CreateNewCompany': 'Neues Unternehmen erstellen',
  'Component.SearchCreateCompanyModal.Description1PendingTask': 'Ausstehende Aufgabe für das Unternehmen. Keine Entsprechung in HubSpot gefunden. Bitte wählen Sie ein vorhandenes Unternehmen oder erstellen Sie ein neues. Die Aufgabe wird automatisch erstellt.',
  'Component.CreateHubspotTask.Form.AssigneeLabel': 'Zugewiesen an',
  'Component.CreateHubspotTask.Form.Pipeline': 'Pipeline',
  'Component.CreateHubspotTask.Form.DealStage': 'Deal-Stufe',
  'Component.CreateHubspotTask.Form.DueDateLabel': 'Fälligkeitsdatum',
  'Component.CreateHubspotTask.Form.NotesLabel': 'Notizen',
  'Component.CreateHubspotTask.Form.Priority': 'Deal Priorität',
  'Component.CreateHubspotTask.Form.PriorityLow': 'Niedrig',
  'Component.CreateHubspotTask.Form.PriorityMedium': 'Mittel',
  'Component.CreateHubspotTask.Form.PriorityHigh': 'Hoch',
  'Component.CreateHubspotTask.Form.CreateTransferButton': 'Zu Hubspot übertragen',
  'Component.CreateHubspotTask.Form.Back': 'Zurück',
  'Component.CreateHubspotTask.Form.Close': 'Schließen',
  'Component.CreateHubspotTask.Form.Next': 'Nächster Schritt',
  'Component.CreateHubspotTask.Form.Submit': 'Alles im CRM erstellen',
  'Component.CreateHubspotTask.Form.Header.1': 'Kontaktpersonensuche',
  'Component.CreateHubspotTask.Form.Header.2': 'Informationen für Outreach',
  'Component.CreateHubspotTask.Form.Header.3': 'Zusätzliche Informationen',
  'Component.CreateHubspotTask.Form.Header.4': 'CRM-Verantwortlicher',
  'Component.CreateHubspotTask.Form.AgentLabel': 'KI-Outreach-Agent',
  'Component.CreateHubspotTask.Form.AISummary': 'KI-Zusammenfassung',
  'Component.CreateHubspotTask.Form.OutreachEmail': 'Outreach-E-Mail',
  'Component.CreateHubspotTask.Form.SelectPerson.Label': 'Bitte wählen Sie Personen aus der Liste aus.',
  'Component.CreateHubspotTask.Form.Filter.Company': 'Filtern nach Firmennamen',
  'Component.CreateHubspotTask.Form.Filter.Domain': 'Filtern nach Domain',
  'Component.CreateHubspotTask.Form.Filter.Country': 'Filtern nach Land',
  'Component.CreateHubspotTask.Form.Filter.Title': 'Filtern nach Titel',
  'Component.CreateHubspotTask.Form.Filter.Keyword': 'Filtern nach Stichwort',
  'Component.CreateHubspotTask.Form.Filter.Seniority': 'Filtern nach Seniorität',
  'Component.CreateHubspotTask.Form.Filter.ShowAll': 'Alle Filter anzeigen',
  'Component.CreateHubspotTask.Form.Filter.ShowLess': 'Weniger anzeigen',
  'Component.CreateHubspotTask.Form.Filter.NoCompaniesFound': 'Keine Unternehmen gefunden, die den Kriterien entsprechen',
  'Component.CreateHubspotTask.Form.Filter.ZeroCompany': '"{companyName}" nicht gefunden. Bitte versuchen Sie, manuell zu suchen.',
  'Component.CreateHubspotTask.Form.Filter.MoreThanOneCompany': 'Wir haben mehr als ein "{companyName}" gefunden. Bitte wählen Sie das konkrete aus.',
  'Component.CreateHubspotTask.Form.Filter.NoFilters': 'Bitte wählen Sie ein Unternehmen aus oder geben Sie eine Domain ein',
  'Component.CreateHubspotTask.Form.Validation.URL.Value': 'Muss eine gültige URL sein',
  'Component.SearchCreateCompanyModal.Info.PendingTaskCreatingInProgress': 'Die Erstellung ausstehender Aufgaben ist bereits im Gange',
  'Component.CreateHubspotTask.Form.TaskCreatedNotification': 'Hubspot Aufgabe erfolgreich erstellt',
  'Component.CreateHubspotTask.View.AssignedTo': 'Zugewiesen an',
  'Component.CreateHubspotTask.View.AssignedBy': 'Von {fullname}',
  'Component.CreateHubspotTask.View.DueDate': 'Fälligkeitsdatum',
  'Component.CreateHubspotTask.View.Notes': 'Notizen',
  'Component.CreateHubspotTask.View.HubspotUrl': 'Hubspot Aufgaben-URL',
  'Component.CreateHubspotTask.View.HubspotDealUrl': 'Hubspot Deal-URL',
  'Component.AccountSettings.New.HubspotSection.SelectLxpUsersTitle': 'Benutzerberechtigungen',
  'Component.AccountSettings.New.HubspotSection.SelectLxpUsersDescription': 'Bitte wählen Sie die Benutzer aus, denen Sie Zugriff auf die Hubspot-Funktionen in LXP geben möchten.',
  'Component.LeadScoring.Title.Settings': 'Profil-Einstellungen',
  'Component.LeadScoring.Title.Hubspot': 'HubSpot',
  'Component.LeadScoring.Title.HubspotDescription': 'Aktivieren Sie es, um automatisch HubSpot-Deals zu erstellen, die den unten stehenden Kriterien entsprechen.',
  'Component.LeadScoring.Form.HubspotActive': 'Aktiv',
  'Component.LeadScoring.Form.HubspotTaskAssignee': 'Zuständiger',
  'Component.LeadScoring.Form.DealPipeline': 'Deal-Pipeline',
  'Component.LeadScoring.Form.DealPipelineStage': 'Deal-Stufe',
  'Component.LeadScoring.Grid.HubspotAssignee': 'HubSpot-Zuständiger',
  'Component.LeadScoring.List.SearchByHubspotAssignee': 'Geben Sie einen HubSpot-Zuständigennamen ein',
  'Component.AccountSettings.New.HubspotSection.FeaturesLabel': 'Funktionen',
  'Component.AccountSettings.New.HubspotSection.CreateTaskFeatureLabel': 'Aufgaben erstellen',
  'Component.AccountSettings.New.HubspotSection.CreateDealFeatureLabel': 'Deals erstellen',
  'Component.AccountSettings.New.HubspotSection.DefaultPipelineLabel': 'Standard-Deal-Pipeline',
  'Component.AccountSettings.New.HubspotSection.DefaultPipelinePlaceholder': 'Wählen Sie eine Pipeline',
  'Component.AccountSettings.New.HubspotSection.DefaultDealStagePlaceholder': 'Wählen Sie eine Deal-Stufe',
  'Component.CreateHubspotTask.View.DealPipeline': 'Pipeline',
  'Component.CreateHubspotTask.View.DealStage': 'Deal-Stufe',
  'Component.CreateHubspotTask.View.Priority': 'Deal-Priorität',
  'Component.CreateHubspotTask.View.PriorityValueNone': 'Keine',
  'Component.CreateHubspotTask.Form.DealTopicCustomField': 'Thema',
  'Component.CreateHubspotTask.Form.DealClusterCustomField': 'Cluster',
  'Component.CreateHubspotTask.Form.DealTypeCustomField': 'Typ',
  'Component.CreateHubspotTask.View.DealTopic': 'Thema',
  'Component.CreateHubspotTask.View.DealCluster': 'Cluster',
  'Component.CreateHubspotTask.View.DealType': 'Typ',
  'Component.CreateHubspotTask.View.DealValueNone': 'Keine',
  'Component.AccountSettings.New.HubspotSection.CreateCommentOnNewVisit': 'Update HS bei neuem Besuch',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptTitle': 'KI-Vertriebsassistent',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptDescription1': 'Unten können Sie zusätzliche Anweisungen für den KI-Assistenten eingeben, einschließlich Details zu Ihrem Unternehmen, Produkten, Schwerpunktbereichen und Sprachpräferenzen.',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptDescription2': 'Der KI-Assistent hat Zugriff auf die Unternehmensbeschreibung, Besuchsdetails und verwendete Technologien.',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptDescription3': 'Wählen Sie einfach unten ein Unternehmen aus, um den KI-Assistenten in Aktion zu sehen, wobei der letzte Besuch für die Testaktion verwendet wird.',
  'Component.AccountSettings.Edit.LanguageModelSection.CustomizeYourPromptLabel': 'Passen Sie Ihre Aufforderung an',
  'Component.AccountSettings.Edit.LanguageModelSection.CompanyLabel': 'Wählen Sie ein Unternehmen für einen Test',
  'Component.AccountSettings.Edit.LanguageModelSection.TestCompanyNoCompaniesFound': 'Keine Unternehmen gefunden, die den Kriterien entsprechen',
  'Common.RemoteSelect.Placeholder': 'Bitte beginnen Sie mit der Eingabe, um auszuwählen...',
  'Common.Test': 'Test',
  'Component.AIOutreachAgents.List.Title': 'KI-Outreach-Agent',
  'Component.AIOutreachAgents.List.Description': 'Hier finden Sie alle KI-Outreach-Agenten.',
  'Component.AIOutreachAgents.List.SearchByNamePlaceholder': 'Geben Sie einen Namen ein, um nach einem KI-Outreach-Agenten zu suchen',
  'Component.AIOutreachAgents.List.Create': 'Neuer KI-Outreach-Agent',
  'Component.AIOutreachAgents.New.Success.Text': 'Neuer KI-Outreach-Agent wurde erfolgreich erstellt',
  'Component.AIOutreachAgents.New.Form.Title': 'Neuer KI-Outreach-Agent',
  'Component.AIOutreachAgents.Edit.Success.Text': 'Der KI-Outreach-Agent wurde erfolgreich geändert',
  'Component.AIOutreachAgents.Edit.Form.Title': 'KI-Outreach-Agent bearbeiten',
  'Component.AIOutreachAgents.Remove.Success.Text': 'Der KI-Outreach-Agent wurde erfolgreich entfernt',
  'Component.AIOutreachAgents.Modal.Description': 'Möchten Sie den KI-Outreach-Agenten "{aiOutreachAgentName}" wirklich entfernen?',
  'Component.AIOutreachAgents.Form.Name': 'Name des KI-Outreach-Agenten',
  'Component.AIOutreachAgents.Form.EmailOrLinkedIn': 'E-Mail/LinkedIn',
  'Component.AIOutreachAgents.Form.URLLabel.Title': 'Informationen für Outreach',
  'Component.AIOutreachAgents.Form.URLLabel.Value': 'Webseiten-Label',
  'Component.AIOutreachAgents.Form.URLLabel.Add': 'Webseiten-Label hinzufügen',
  'Component.AIOutreachAgents.Form.Prompt.CardTitle': 'Agenten-Prompt',
  'Component.AIOutreachAgents.Form.Prompt.PromptDescription1': 'Bitte geben Sie hier Informationen über Ihr Unternehmen, Ihre Produkte und Ihre Zielgruppen an. Versuchen Sie so detailliert wie möglich, aber so kurz wie nötig zu beschreiben, welche Produkte und Dienstleistungen Sie an welche Zielgruppen verkaufen/vermitteln.',
  'Component.AIOutreachAgents.Form.Prompt.PromptDescription2': 'Diese Informationen werden später von unserem System als Grundlage verwendet, um individuelle Outreach-E-Mails zu erstellen.',
  'Component.AIOutreachAgents.Form.Prompt.PromptDescription3': 'Daher sollten hier alle relevanten Produkte, eine kurze Beschreibung des Unternehmens und Angaben zu den Zielgruppen gemacht werden.',
  'Component.AIOutreachAgents.Form.Prompt.Company.Label': 'Wählen Sie ein Unternehmen für einen Test aus',
  'Component.AIOutreachAgents.Form.Prompt.Company.NotFound': 'Keine Unternehmen gefunden, die den Kriterien entsprechen',
  'Component.AIOutreachAgents.Validation.Name': 'Bitte geben Sie den Namen des KI-Outreach-Agenten ein',
  'Component.AIOutreachAgents.Validation.URLLabel.Value': 'Bitte geben Sie ein Webseiten-Label ein',
  'Component.AIOutreachAgents.Validation.EmailOrLinkedIn': 'Muss eine gültige E-Mail oder LinkedIn-URL sein',
  'Component.AIOutreachAgents.Validation.URL.Value': 'Muss eine gültige URL sein',
};



// WEBPACK FOOTER //
// ./src/i18n/de.js